<template>
    <div>
        <div v-if="$wait.is('fetching_comments')" class="loading">
            <Spinner :height="40" :width="40"/>
        </div>
        <template v-else>
            <div class="sector-post__comments" v-if="resource && resource.length > 0">
                <div class="comment" v-for="comment in resource">
                    <Avatar
                        :resource="comment.user"
                        :show-name="false"
                        class="comment__avatar"
                    />
                    <article class="comment__content">
                        <header class="comment__metadata">
                            <span class="comment__author">
                                <span class="name" v-if="comment.user.name">
                                    {{ comment.user.name }}
                                    <span
                                        class="member"
                                        v-if="comment.user.member"
                                        v-text="comment.user.member"
                                    />
                                </span>
                            </span>
                            <span v-if="comment.date" class="comment__date">
                                <a href="#" @click.prevent.stop="handleDeleteClicked(comment.id)"  v-if="comment.can && comment.can.delete">Delete</a>
                                <span v-if="comment.is_edited">Edited </span>
                                {{ comment.date }}
                            </span>
                        </header>
                        <ReadMore
                            v-if="comment.message"
                            :content="comment.message"
                            :wrapper-class="{'comment_message': true}"
                        />
                    </article>
                </div>
            </div>
            <div v-else class="no-results">
                <span>There are currently no comments — be the first to share your thoughts!</span>
            </div>
        </template>
    </div>
</template>


<script>
import Avatar from '@components/Avatar.vue';
import ReadMore from '@components/ReadMore.vue';
import API from '@api';
import Spinner from '@components/Spinner.vue';
import LayoutWithContainer from '@layouts/LayoutWithContainer.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'SectorPostCardComments',
    components: {
        LayoutWithContainer,
        Spinner,
        ReadMore,
        Avatar,
    },
    props: {
        id: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            resource: null,
        }
    },
    methods: {
        async fetchResource() {
            try {
                this.resource = await API.getSectorPostComments(this.id);
            } catch(err) {
                console.warn({ err });
                this.resource = null;
            } finally {
                this.$wait.end('fetching_comments');
            }
        },
        handleDeleteClicked(commentId) {
            this.$modal.show('dialog', {
                title:'Are you sure?',
                text: 'Clicking DELETE will remove this comment.',
                buttons: [
                    {
                        class: 'btn btn--danger',
                        title: this.$wait.is('is_deleting') ? 'Deleting...' : 'DELETE',
                        handler: () => {
                            this.handleDelete(commentId);
                        }
                    },
                ]
            });
        },
        async handleDelete(commentId) {
            this.$wait.start('is_deleting')

            try {
                await API.deleteSectorPostComment(this.id, commentId);
                this.resource = this.resource.filter((item) => item.id !== commentId);
            } catch(err){
                console.warn(err.message);
            } finally {
                this.$modal.hide('dialog');
                this.$wait.end('is_deleting');
            }
        }
    },
    computed: {
        ...mapGetters([
            'can',
        ])
    },
    mounted() {
      console.log("mounted");
        this.$wait.start('fetching_comments');
        this.fetchResource();
    },
}
</script>
<style lang="scss" scoped>
@import '~@/theme/_variables.scss';

.comment {
    display: flex;
    align-items: flex-start;
    column-gap: 1rem;
    padding: 1rem 2rem;

    .comment__content {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        max-width: calc(100% - 5rem);

        .comment__metadata {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 1rem;

            .comment__author {

                white-space: nowrap;
                overflow: hidden;
                flex: 1 1 calc(100% - 18rem);
                max-width: calc(100% - 18rem);
                text-overflow: ellipsis;

                .name {
                    font-size: 1.4rem;
                    line-height: 1.4rem;
                    font-weight: 500;
                }

                .member {
                    font-size: 1.2rem;
                    line-height: 1.4rem;
                    color: $text;
                    font-weight: 400;
                }
            }

            .comment__date {
                color: $text;
                font-size: 1.2rem;
                line-height: 1.4rem;
                flex: 0 0 19rem;
                text-align: right;
            }
        }

        .comment_message {

        }
    }
}

</style>
<style lang="scss">
    @import '~@/theme/_variables.scss';

    .no-results {
        height: 10rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: $text;
    }
</style>
